import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {of, switchMap} from 'rxjs';
import {catchError, take} from 'rxjs/operators';
import {AuthenticationService} from '../service';


/**
 * A custom HTTP interceptor function that handles CSRF token mismatch errors (HTTP 419).
 *
 * This interceptor listens for HTTP 419 responses with a "CSRF token mismatch"
 * error message. When such an error occurs, it attempts to resolve the issue by
 * fetching a new CSRF cookie and retrying the request. If other errors are encountered,
 * they are propagated without modification.
 */
export const csrfCookieMishmashInterceptor: HttpInterceptorFn = (req, next) => {
    const authenticationService = inject(AuthenticationService);
    return next(req.clone())
      .pipe(
          catchError(err => {
              if (err.status === 419 ) {
                  // get new cookie in case of CSRF token failure and try again
                  return authenticationService.getCSRFCookie()
                      .pipe(
                          take(1),
                          switchMap(() => next(req)),
                          catchError(error=>{
                              return of(error);
                          }),
                      )
              }
             throw err;
          })
      );
};
